import React, { ChangeEvent, forwardRef, Ref, useState } from 'react';
import { Input } from '@components/input';

import { SimpleDateInputProps } from './simple-date-input.type';
const DATE_PATTERN = /^(([0-2]?\d{1})|([3][0,1]{1}))\/[0,1]?\d{1}\/(([1]{1}[9]{1}[0-9]{1}\d{1})|([2]{1}[0]{1}\d{2}))$/;
const DIGITS_SLASH = /([^0-9]|\^\/)/g;
export const SimpleDateInput = forwardRef(
  ({ onValid, onInvalid, onChange, hasError, ...props }: SimpleDateInputProps, ref: Ref<HTMLInputElement>) => {
    const [inputValue, setInputValue] = useState('');

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
      const { value } = event.target;
      const sanitizedValue = value.replace(DIGITS_SLASH, '');
      let formattedValue = '';

      for (let i = 0; i < sanitizedValue.length; i++) {
        if ([2, 4].includes(i)) {
          formattedValue += '/';
        }
        formattedValue += sanitizedValue[i];
      }
      if (formattedValue.length > 10) {
        return;
      }
      const isValid = DATE_PATTERN.test(formattedValue);

      setInputValue(formattedValue);
      onChange(event);

      if (onValid && isValid) {
        onValid(formattedValue);
      }
      if (onInvalid && !isValid) {
        onInvalid(formattedValue);
      }
    };

    return (
      <Input
        {...props}
        ref={ref}
        type='text'
        value={inputValue}
        onChange={handleChange}
        hasError={hasError}
        placeholder='DD/MM/YYYY'
      />
    );
  }
);
